"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupWorkspace = setupWorkspace;
const activityLogUI_1 = require("./activityLogUI");
const puzzle_1 = require("./puzzle");
const matching_1 = require("./matching");
const activation_1 = require("./activation");
const navigation_1 = require("./navigation");
const sketchpad_1 = require("./sketchpad");
const themes_1 = require("./theme/themes");
function setupWorkspace(options) {
    const activityLog = (0, activityLogUI_1.setupActivityLog)();
    const balloons = document.getElementById('balloons-view');
    const sketchHost = document.getElementById('sketchpad-view');
    const matchingHost = document.getElementById('matching-view');
    const trigger = document.getElementById('background-toggle');
    const panel = document.getElementById('background-menu');
    const input = document.querySelector('#background-file');
    const drawingButton = document.querySelector('#drawing-background');
    const status = document.getElementById('background-status');
    let sketch = null;
    let matching = null;
    const puzzleHost = document.getElementById('puzzle-view');
    let puzzle = null;
    let ownedUrl = null;
    let request = 0;
    const close = () => { panel.hidden = true; trigger.setAttribute('aria-expanded', 'false'); };
    const exitSimple = document.getElementById('exit-simple-mode');
    (0, activation_1.bindActivation)(document.getElementById('simple-mode'), () => {
        request++;
        options.setSimpleMode(true);
        report(apply(null).then(() => {
            balloons.classList.add('simple-mode');
            exitSimple.hidden = false;
            exitSimple.focus();
        }));
    });
    (0, activation_1.bindActivation)(exitSimple, () => {
        options.setSimpleMode(false);
        balloons.classList.remove('simple-mode');
        exitSimple.hidden = true;
        trigger.focus();
    });
    const apply = async (url, owned = false) => {
        const previous = ownedUrl;
        await options.setBackground(url);
        ownedUrl = owned ? url : null;
        if (previous && previous !== ownedUrl)
            window.setTimeout(() => URL.revokeObjectURL(previous), 3000);
        status.textContent = '';
        close();
    };
    const useBlob = async (blob) => {
        const token = ++request;
        const url = URL.createObjectURL(blob);
        try {
            const image = new Image();
            image.src = url;
            await image.decode();
            if (token !== request) {
                URL.revokeObjectURL(url);
                return;
            }
            await apply(url, true);
        }
        catch (error) {
            URL.revokeObjectURL(url);
            throw error;
        }
    };
    const report = (work) => {
        status.textContent = 'Loading image?';
        void work.catch(() => { status.textContent = 'Could not load that image. Please try another.'; });
    };
    // Simple mode changes the controls, preserving the saved object selection.
    balloons.classList.add('simple-mode');
    exitSimple.hidden = false;
    options.setSimpleMode(true);
    report(apply(null));
    (0, activation_1.bindActivation)(trigger, () => {
        const open = panel.hidden;
        panel.hidden = !open;
        trigger.setAttribute('aria-expanded', String(open));
        if (open) {
            const bounds = trigger.getBoundingClientRect();
            const anchor = trigger.parentElement.getBoundingClientRect();
            const menuWidth = Math.min(260, window.innerWidth - 32);
            const left = Math.max(16, Math.min(bounds.left, window.innerWidth - menuWidth - 16));
            panel.style.left = `${left - anchor.left}px`;
            panel.style.right = 'auto';
            panel.style.maxHeight = `${Math.max(120, window.innerHeight - bounds.bottom - 24)}px`;
            panel.style.overflowY = 'auto';
            panel.querySelector('button')?.focus();
        }
    });
    for (const button of panel.querySelectorAll('[data-background]')) {
        (0, activation_1.bindActivation)(button, () => {
            request++;
            const id = button.dataset.background;
            const url = id === 'auto' ? null : themes_1.themes[id].background;
            report(apply(url));
        });
    }
    (0, activation_1.bindActivation)(document.getElementById('upload-background'), () => input.click());
    input.addEventListener('change', () => {
        const file = input.files?.[0];
        input.value = '';
        if (file)
            report(useBlob(file));
    });
    (0, activation_1.bindActivation)(drawingButton, () => {
        if (sketch)
            report(sketch.snapshot().then(useBlob));
    });
    panel.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
            close();
            trigger.focus();
        }
    });
    document.addEventListener('pointerdown', event => {
        const target = event.target;
        if (!panel.contains(target) && !trigger.contains(target))
            close();
    });
    (0, navigation_1.setupNavigation)(requestedView => {
        const view = options.resolveView?.(requestedView) ?? requestedView;
        activityLog.view(view);
        const drawing = view === 'sketchpad';
        const playing = view === 'matching';
        const balloonView = view === 'balloons';
        puzzleHost.hidden = view !== 'puzzle';
        if (view === 'puzzle' && !puzzle)
            puzzle = (0, puzzle_1.mountPuzzle)(puzzleHost, activityLog.puzzle, options.showScreensaver);
        puzzle?.setActive(view === 'puzzle');
        close();
        if (!balloonView)
            options.showBalloons(false);
        balloons.hidden = !balloonView;
        sketchHost.hidden = !drawing;
        matchingHost.hidden = !playing;
        if (playing && !matching)
            matching = (0, matching_1.mountMatching)(matchingHost);
        matching?.setActive(playing);
        if (drawing && !sketch) {
            sketch = (0, sketchpad_1.mountSketchpad)(sketchHost, async (blob) => {
                await useBlob(blob);
                window.location.hash = '/balloons';
            });
            drawingButton.disabled = false;
        }
        sketch?.setActive(drawing);
        // Resize only after the balloon canvas is visible again.
        if (balloonView)
            options.showBalloons(true);
        document.title = view === 'puzzle' ? 'Picture puzzles | Balloons' : drawing ? 'Sketchpad | Balloons' : playing ? 'Little letter shop | Balloons' : 'Balloons';
    });
}
//# sourceMappingURL=workspace.js.map